import React from 'react';

import {
  useCreateCustomFieldValueMutation,
  useUpdateCustomFieldValueMutation,
  useDeleteCustomFieldValueMutation,
} from './hooks';
import { useTeamsQuery } from './hooks/useTeamsQuery';
import { CustomFieldValuesList } from '../../components/CustomFieldValuesList';
import { type CustomField } from '../../models/customField';

type Props = {
  customField: CustomField;
  selectedValueIds: string[];
  onSelectedValuesChange: (
    selectedValueIds: string[],
    customFieldId: string,
  ) => void;
};

export const CustomFieldValuesListContainer = ({
  customField,
  selectedValueIds,
  onSelectedValuesChange,
}: Props) => {
  const [createCustomFieldValue] = useCreateCustomFieldValueMutation(
    customField.id,
  );
  const [updateCustomFieldValue] = useUpdateCustomFieldValueMutation(
    customField.id,
  );
  const [deleteCustomFieldValue] = useDeleteCustomFieldValueMutation(
    customField.id,
  );

  const teamsQueryState = useTeamsQuery();

  if (teamsQueryState.status !== 'success') {
    return null;
  }

  return (
    <CustomFieldValuesList
      customField={customField}
      teams={teamsQueryState.data}
      selectedValueIds={selectedValueIds}
      onUpdateCustomFieldValue={updateCustomFieldValue}
      onCreateCustomFieldValue={createCustomFieldValue}
      onDeleteCustomFieldValue={deleteCustomFieldValue}
      onSelectedValuesChange={onSelectedValuesChange}
    />
  );
};
